export default "__VITE_ASSET__PlgIA1Vd__"